import { Controller } from "@hotwired/stimulus"
//import Chart from "chart.js/auto"

export default class extends Controller {
  static values = {
    data: Array,
    colors: Array,
    title: String
  }

  connect() {
    console.log('Demographics chart controller connected')

    this.createChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  createChart() {
    console.log('Creating chart...')

    if (this.chart) {
      console.log('Chart already exists, skipping')
      return
    }

    console.log('Element:', this.element)
    console.log('Data:', this.dataValue)
    console.log('Colors:', this.colorsValue)

    const chartData = this.prepareChartData()
    console.log('Prepared chart data:', chartData)

    // Detect if we're in a PDF/print context
    const isPrintContext = window.matchMedia && window.matchMedia('print').matches

    this.chart = new Chart(this.element, {
      type: 'bar',
      data: chartData,
      options: {
        animation: false, // Disable animations for PDF rendering
        responsive: true, //!isPrintContext, // Disable responsive in print context
        maintainAspectRatio: false,
        //aspectRatio: 3.0, // Adjust width:height ratio to prevent stretching
        devicePixelRatio: 2.0,
        plugins: {
          title: {
            display: true,
            text: this.titleValue || 'Demographics by Age Group'
          },
          legend: {
            position: 'top',
            labels: {
              boxWidth: 8,
              boxHeight: 8,
              padding: 12,
              font: {
                size: 12,
              },
            },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            grid: {
              drawBorder: false,
              display: false
            },
          },
          x: {
            grid: {
              drawBorder: false,
              display: false
            },
          }
        }
      }
    })

    console.log('Chart created successfully')
  }

  prepareChartData() {
    const data = this.dataValue
    const [primaryColor, secondaryColor] = this.colorsValue

    // Safety check for data
    if (!data || !Array.isArray(data) || data.length === 0) {
      console.warn('No data provided for chart')
      return {
        labels: [],
        datasets: []
      }
    }

    // Filter out totals rows and extract labels and data
    const filteredData = data.filter(row =>
      row &&
      row[0] &&
      !row[0].toString().toLowerCase().includes('total')
    )

    if (filteredData.length === 0) {
      console.warn('No valid data after filtering')
      return {
        labels: [],
        datasets: []
      }
    }

    const labels = filteredData.map(row => row[0] || 'Unknown') // Age bands

    // Extract volume data - using total volumes (columns 6 and 12 from reordered structure)
    // Column 6: Current Total Volume, Column 12: Previous Total Volume
    const currentVolumes = filteredData.map(row => {
      const value = row[6] // Current Total Volume
      return typeof value === 'number' ? value : (parseInt(value) || 0)
    })

    const previousVolumes = filteredData.map(row => {
      const value = row[12] // Previous Total Volume
      return typeof value === 'number' ? value : (parseInt(value) || 0)
    })

    const result = {
      labels: labels,
      datasets: [
        {
          label: 'Prior',
          data: previousVolumes,
          backgroundColor: secondaryColor, // + '80', // Add transparency
          borderColor: secondaryColor,
          borderWidth: 1
        },
        {
          label: 'Current',
          data: currentVolumes,
          backgroundColor: primaryColor, // + '80', // Add transparency
          borderColor: primaryColor,
          borderWidth: 1
        }
      ]
    }

    console.log('Data:', result)

    return result
  }
}
